const state = {
    items: {
        data: [],
        total: 0,
    },
    item: {
        ld_number: null,
        ld_date: new Date(),
        status: "Draft",
        client_contract_id: null,
        gl_code_id: null,
        supplier_id: null,
        order_id: null,
        total: null,
        reasons: null,
        description: null,
        created_at: null,
        gl_code: null,
        contract: null,
        supplier: null,
        payment_voucher: null,
        created_by_user: null,
    },
};

const getters = {
    historyItems: (state) => state.items,
    item: (state) => state.item,
};


const actions = {
    async getContract({ commit }, params) {

        return new Promise((resolve, reject) => {

            global.axios(`/api/contracts/` + params, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    /* Item History*/
    async getPartReplacementHistory({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/equipment/part-replacement-history`, { params: params })
                .then(response => {
                    commit('setItems', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async getPartReplacementHistoryHeader({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/equipment/part-replacement-history-header`, { params: params })
                .then(response => {
                    //commit('setItems', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getPartReplacement({ commit }, id) {
        return new Promise((resolve, reject) => {
            global.axios(`api/equipment/part-replacement-history/${id}`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    commit('setItem', response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error)
                });
        });
    },
    async createItem({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/equipment/part-replacement-history`, data)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async updateItem({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.put(`api/equipment/part-replacement-history/${data.livs_transaction_id}`, data)
                .then(response => {
                    commit('setItem', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async updateItemDetail({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.put(`api/equipment/part-replacement-history-item/${data.id}`, data)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    //importItems
    async importItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append('file_import', params.file_import);
            formData.append('contract_id', params.contract_id);
            global.axios.post(`api/equipment/part-replacement-history/import`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },

    async exportItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/equipment/part-replacement-history/export`, { params: params })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },

    /* Item Detail*/
    async getDetailItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/equipment/part-replacement-history-item`, { params: params })
                .then(response => {
                    commit('setItems', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async createItemDetail({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/equipment/part-replacement-history-item
                `, data)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async deleteItems({ commit }, ids) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/equipment/part-replacement-history-item`, {
                    data: {
                        ids: ids
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        })
    },
    async deleteHeaders({ commit }, ids) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/equipment/part-replacement-history`, {
                    data: {
                        ids: ids
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        })
    },
    /*Part Location*/
    async getPartLocation({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/part-location`, { params: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async createPartLocation({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/part-location`, params)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async updatePartLocation({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.put(`api/part-location/${data.id}`, data)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async deletePartLocation({ commit }, ids) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/part-location`, {
                    data: {
                        ids: ids
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        })
    },
    async getEquipment({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/part-replacement/equipment`, { params: params })
                .then(response => {
                    //commit('setItems', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    /*Check Active Wa*/
    async checkActiveWarranty({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/equipment/part-replacement-history-item/check-active-warranty`, { params: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    /*Lift Manufacturer*/
    async getListLiftManufacturer({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/lift-manufacturer`, { params: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async updateStatusPartsReplacement({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append('id', params.id);
            formData.append('status', params.status);
            formData.append('reason_id', params.reason_id || '');

            for(let i = 0; i < params.files.length; i++){
                formData.append(`files[${i}]`, params.files[i].file);
                if(i==0){
                    formData.append('reference_id', params.files[i].reference_id);
                }
            }

            global.axios.post(`api/equipment/part-replacement-history/` + params.livs_transaction_id + `/status`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        });
    },
    async massPrint({ commit }, ids) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/part-replacement/mass-print`, {
                ids: ids,
            })
            .then(response => {
                resolve(response.data.data);
            })
            .catch(error => reject(error));
        })
    },
    async updateWONumber({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/equipment/part-replacement-history/wo/`, data)
            .then(response => {
                resolve(response.data.data);
            })
            .catch(error => reject(error));
        });
    },
};

const mutations = {
    setItems(state, data) {
        state.items = Object.assign(state.item, data);
    },
    setItem(state, data) {
        state.item = data;
    },
    resetItem(state) {
        state.item = {
            ld_number: null,
            ld_date: new Date(),
            status: "Draft",
            client_contract_id: null,
            gl_code_id: null,
            supplier_id: null,
            order_id: null,
            total: null,
            reasons: null,
            description: null,
            created_at: null,
            gl_code: null,
            contract: null,
            supplier: null,
            payment_voucher: null,
            created_by_user: null
        };
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}